import React, { useEffect, useState } from "react";
import ErrorBoundary from "../common/errorBoundary";
import moment from "moment-timezone";
import * as timexHelper from "../common/helper";
import FlightSchedule from "../containers/flightSchedule";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as flightDetailsActiona from "../actions/flightDetails";
import * as stationAction from "../actions/stationNames";
import { useHistory } from "react-router-dom";
import * as config from "../data/config";
import LocalStorageHelper from "../common/localStorageHelper";

const styles = {
    backButton: {
        marginLeft: "5%",
        marginTop: "5%",
    },
    refreshButton: {
        marginRight: "5%",
        marginTop: "5%",
    },
    refreshTime: {
        display: "block",
        fontSize: "12px",
        color: "white",
        textAlign: "center",
        width: "100%",
    },
};

function FlightsPage(props) {
    const history = useHistory();

    useEffect(() => {
        if (!props.selectedStation) {
            history.push("/"); // return to station selection page if no station selected.
        }

        let url = "";
        let { baseURL, getFlightDetailsURL } = config.environment.api;
        let flightDetailsEndpoint = baseURL + getFlightDetailsURL;
        if (props.selectedStation.toLowerCase() !== "select station") {
            url = flightDetailsEndpoint + "/" + props.selectedStation;
        }

        let token = "";
        let user = LocalStorageHelper.getUser();
        if (user && user.token) {
            token = user.token;
        }

        props.actions.setLoader(true);

        fetch(url, { headers: { Authorization: token } })
            .then((response) => response.json())
            .then((data) => {
                LocalStorageHelper.selectedStation.set(props.selectedStation);
                LocalStorageHelper.appliedFilters.set(null);
                const storedStation = LocalStorageHelper.selectedStation.get();
                var flightFilters =
                    LocalStorageHelper.appliedFilters.get() ?? timexHelper.GetDefaultFlightFilters(storedStation);

                props.actions.setFlightDetails(data, flightFilters, true);

                props.actions.setLoader(false);
                setTimeout(() => {
                    props.actions.setLoader(false);
                }, 2000);
            });
    }, []);

    const onResetHandler = () => {
        LocalStorageHelper.appliedFilters.set(null);
        props.actions.resetFlight();
        history.push("/");
    };

    const onRefreshHandler = () => {
        var flightFilters =
            LocalStorageHelper.appliedFilters.get() ?? timexHelper.GetDefaultFlightFilters(props.selectedStation);

        props.actions.getFlightData(flightFilters, props.selectedStation);
    };

    return (
        <ErrorBoundary>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <button style={styles.backButton} className="btn btn-primary" onClick={onResetHandler}>
                    Back{" "}
                </button>
                <button style={styles.refreshButton} className="btn btn-primary" onClick={onRefreshHandler}>
                    Refresh{" "}
                </button>
            </div>
            <div>
                {props.refreshedTime && (
                    <span style={styles.refreshTime}>
                        Refreshed at {props.refreshedTime} {props.selectedStation} time
                    </span>
                )}
            </div>
            <FlightSchedule stationCode={props.selectedStation} noData />
        </ErrorBoundary>
    );
}

const mapStateToProps = (state) => {
    const { filteredFlightDetails, isFetched, refreshedTime } = state.flightDetail;
    const { allStations, requestInProgress, selectedStation } = state.StationDetail;

    return {
        allStations,
        filteredFlightDetails,
        isFetched,
        requestInProgress,
        selectedStation,
        refreshedTime,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, flightDetailsActiona, stationAction), dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsPage);
